import { BACKEND_URL } from './apiConfig';
import { authFetch } from './authHelpers';
import { leesJson } from './apiFout';

/**
 * Afbeeldingen in notities (Joris, 7 sep 2026).
 *
 * De markdown bewaart een relatieve URL (`/Api/project-notes/afbeelding/nt_<32hex>.png`),
 * zodat dezelfde notitie op test en productie werkt. `absoluteAfbeeldingsUrl` zet daar de
 * backend voor; de kijkroute is publiek (de naam is de sleutel) en geeft een 302 naar een
 * kortlevende SAS, dus een gewone <img> kan hem laden.
 */
export const AFBEELDING_MAX_BYTES = 8 * 1024 * 1024;
const TOEGESTAAN = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp'];

export function isNotitieAfbeelding(file) {
  return !!file && TOEGESTAAN.includes((file.type || '').toLowerCase());
}

export function absoluteAfbeeldingsUrl(src) {
  if (!src) return src;
  return src.startsWith('/Api/') ? `${BACKEND_URL}${src}` : src;
}

const alsDataUrl = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = () => reject(new Error('Bestand niet leesbaar'));
  r.readAsDataURL(file);
});

/** Upload één afbeelding; geeft de relatieve URL voor in de markdown terug. */
export async function uploadNotitieAfbeelding(file) {
  if (!isNotitieAfbeelding(file)) throw new Error('Alleen PNG, JPG, GIF of WebP');
  if (file.size > AFBEELDING_MAX_BYTES) throw new Error('Afbeelding groter dan 8 MB');
  const data = await alsDataUrl(file);
  const r = await authFetch(`${BACKEND_URL}/Api/project-notes/afbeelding`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data, content_type: file.type }),
  });
  const d = await leesJson(r, 'Afbeelding uploaden');
  if (!d?.url) throw new Error('Afbeelding uploaden mislukt: geen URL terug');
  return d.url;
}

/** Afbeeldingsbestanden uit een plak- of sleepactie (leeg als er geen zijn). */
export function afbeeldingenUit(dataTransfer) {
  const uit = [];
  const items = dataTransfer?.items ? Array.from(dataTransfer.items) : [];
  for (const it of items) {
    if (it.kind === 'file') { const f = it.getAsFile(); if (isNotitieAfbeelding(f)) uit.push(f); }
  }
  if (!uit.length && dataTransfer?.files) {
    for (const f of Array.from(dataTransfer.files)) if (isNotitieAfbeelding(f)) uit.push(f);
  }
  return uit;
}
